import React, { useState } from 'react';

import { Button, Dialog, Icon, Text } from '@betterment/samba-react';

import { OutboundIntegration, OutboundIntegrationType } from '../../../graphql/schema';
import { Notification } from '../FirmIntegrationsPage';
import IntegrationConnectModal from '../IntegrationConnectModal';
import IntegrationConnectModalFooter from '../IntegrationConnectModalFooter';

const IntegrationConnectionStatus: React.FC<{
  integration: OutboundIntegration;
  setNotification: (notification: Notification) => void;
}> = ({ integration, setNotification }) => {
  const { isSubscribed, name } = integration;
  const [isConnectModalOpen, setIsConnectModalOpen] = useState<boolean>(false);

  const wealthSuccess = `Your firm is connected to ${name}. Data may take up to one business day to reach your partner account.`;
  const fourOhOneKSuccess = `Your firm is connected to ${name}. Advisors can now enable integrations for their plans.`;

  const is401k = integration.integrationType === OutboundIntegrationType.Advised_401KCustodialFeed;

  if (isSubscribed) {
    return (
      <Text
        data-testid="integrationConnectedStatusTag"
        variant="text100"
        css={{
          py: 'space.50',
          display: 'flex',
          alignItems: 'center',
          width: 'fit-content',
        }}
      >
        <Icon
          name="CheckmarkCircle"
          size="xsmall"
          css={{
            mr: 'space.50',
          }}
        />
        Connected
      </Text>
    );
  }
  return (
    <Dialog open={isConnectModalOpen} onOpenChange={setIsConnectModalOpen} overlay="default">
      <Dialog.Trigger asChild={true}>
        <Button variant="solidPrimary" spacing="compact">
          Connect to {name}
        </Button>
      </Dialog.Trigger>
      <IntegrationConnectModal integration={integration} title={`Connect to ${name}`}>
        <IntegrationConnectModalFooter
          integration={integration}
          saveHandler={() => {
            setNotification({
              variant: 'success',
              message: is401k ? fourOhOneKSuccess : wealthSuccess,
            });
            setIsConnectModalOpen(false);
          }}
        />
      </IntegrationConnectModal>
    </Dialog>
  );
};

export default IntegrationConnectionStatus;
